import {RouteLocationRaw} from "vue-router";

const KEY = "partner_push_pending_navigation";
export type PushNavigationIds = {alarmUserId?: number; eventId?: string; recipientId: number};

const positiveInt = (value: unknown): number | null => {
  if (typeof value !== "string" && typeof value !== "number") return null;
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export function parsePushNavigation(query: Record<string, unknown>): PushNavigationIds | null {
  const alarmUserId = positiveInt(query.alarm_user_id);
  const recipientId = positiveInt(query.recipient_id);
  const eventId = typeof query.event_id === "string" && /^[a-f0-9]{64}$/i.test(query.event_id) ? query.event_id : null;
  if (!recipientId || (!alarmUserId && !eventId)) return null;
  return eventId ? {eventId, recipientId} : {alarmUserId: alarmUserId!, recipientId};
}

export function savePendingPushNavigation(ids: PushNavigationIds): void {
  sessionStorage.setItem(KEY, JSON.stringify(ids));
}

export function consumePendingPushNavigation(): RouteLocationRaw | null {
  try {
    const ids = JSON.parse(sessionStorage.getItem(KEY) || "null") as PushNavigationIds | null;
    sessionStorage.removeItem(KEY);
    if (!ids) return null;
    return {name: "push-notification", query: {
      ...(ids.alarmUserId ? {alarm_user_id: ids.alarmUserId} : {event_id: ids.eventId}),
      recipient_id: ids.recipientId,
    }};
  } catch (_) { sessionStorage.removeItem(KEY); return null; }
}
